import { render, staticRenderFns } from "./lastUsedColors.vue?vue&type=template&id=fbe49a10&scoped=true&"
import script from "./lastUsedColors.vue?vue&type=script&lang=js&"
export * from "./lastUsedColors.vue?vue&type=script&lang=js&"
import style0 from "./lastUsedColors.vue?vue&type=style&index=0&id=fbe49a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe49a10",
  null
  
)

export default component.exports